import map from 'lodash/map';

import PropTypes from 'prop-types';
import React from 'react';

const ContigencyTableComponent = ({ bars, firstParameter, secondParameter, levels }) =>
  <div className="content-item">
    <p className="font-700 mb-10">
      Contingency Table
    </p>

    <table className="main-table main-table--2category" id="contigency-table">
      <colgroup>
        <col className="bg-grey-150" />
      </colgroup>

      <thead>
        <tr>
          <th className="text-right">
            {secondParameter}
          </th>

          {map(levels, level =>
            <th rowSpan="2" className="text-right" key={level.name}>
              {level.name}
            </th>
          )}
        </tr>

        <tr>
          <th>
            {firstParameter}
          </th>
        </tr>
      </thead>

      <tbody>
        {bars.map(bar =>
          <tr key={bar.name}>
            <td className="font-13 font-700">
              {bar.name}
            </td>

            {map(levels, (level =>
              <td
                key={level.name}
                className="text-right"
                id={`${bar.name}${level.name}-count`}
              >

                {(bar.levels[level.name] && bar.levels[level.name].count) || '-'}
              </td>
            ))}
          </tr>
        )}
      </tbody>
    </table>
  </div>;

ContigencyTableComponent.propTypes = {
  bars: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      count: PropTypes.number.isRequired,
      levels: PropTypes.object.isRequired
    }).isRequired
  ).isRequired,

  firstParameter: PropTypes.string.isRequired,
  secondParameter: PropTypes.string.isRequired,

  levels: PropTypes.object.isRequired
};

export default ContigencyTableComponent;
